module.exports = __webpack_public_path__ + "img/heater-house.82c7414.webp";